var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fill-height"},[(_vm.isDesktopView)?_c('HomePageDesktop'):_vm._e(),(_vm.isMobileView)?_c('HomePageMobile'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }